import { render, staticRenderFns } from "./FormTransactionTypeLocale.vue?vue&type=template&id=aa925600&scoped=true&"
import script from "./FormTransactionTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormTransactionTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa925600",
  null
  
)

export default component.exports